<div class="c-not-found">
  <h1>404</h1>
  <h2>{{ 'NOT_FOUND.SUBTITLE' | translate }}</h2>
  <a class="u-link" [routerLink]="['/']">{{ 'NOT_FOUND.GO_BACK_TO_HOME_PAGE' | translate }}</a>
</div>
